import React from "react";

import {
  AccessTimeOutlined,
  Circle,
  MoreHoriz,
  OpenInNew,
  PersonOutline,
} from "@mui/icons-material";
import {
  Box,
  ButtonBase,
  Card,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { connect } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";

import AddJobImg from "../../../assets/images/add-assessment-button.png";
import { selectAssessmentById } from "../../../redux/slices/myAssessmentsSlice";
import { getCamelCaseWord } from "../../../utils/functions";

const AssessmentGridViewCard = ({ assessment, id, index }) => {
  const navigate = useNavigate();

  if (id === "create-job-button") {
    return (
      <ButtonBase
        onClick={() => navigate("/assessments")}
        sx={{
          width: "100%",
          border: 2,
          borderStyle: "dashed",
          borderRadius: "5px",
          borderColor: "#d1d1d1",
          backgroundImage: `url(${AddJobImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "350px",
        }}
      />
    );
  }

  return (
    <Card
      sx={{
        borderRadius: "16px",
        height: "350px",
        boxShadow: "0px 10px 20px 0px #0000000D",
      }}
    >
      <Box
        width="100%"
        bgcolor="#22C55E"
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={1}
        py={0.5}
      >
        <Circle sx={{ width: "7px", height: "7px", color: "white" }} />
        <Typography
          color="white"
          fontFamily="Outfit"
          fontWeight={500}
          fontSize="14px"
        >
          Active
        </Typography>
      </Box>
      {/* )} */}
      <Box
        p={2}
        height="70%"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
      >
        <Box
          display="flex"
          width="100%"
          gap={1}
          my={1}
          justifyContent="space-between"
        >
          <Box flex={1}>
            <Typography
              fontSize="17px"
              textAlign="left"
              fontWeight={600}
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 5,
              }}
            >
              {assessment?.assessment_name}
            </Typography>
          </Box>
          <Box flex={0.7} bgcolor="#99900">
            <Box display="flex" gap={0.5} justifyContent="flex-end">
              <AccessTimeOutlined
                sx={{ width: "17px", height: "17px", color: "#999" }}
              />
              <Typography fontSize="11px">
                Last Activity:{" "}
                {dayjs(assessment?.last_activity).format("MMM D")}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box display="flex" gap={0.5} alignItems="center">
          <PersonOutline
            sx={{ width: "16px", height: "16px", color: "#999" }}
          />
          <Typography fontSize="13px" fontWeight={500}>
            {assessment?.candidates_attempted} Candidates Attempted
          </Typography>
        </Box>
      </Box>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Link
            component={NavLink}
            to={`/interview-candidates/${assessment?.id}/assessment`}
            sx={{
              p: 1,
              textDecoration: "none",
              fontSize: "12px",
              color: "#00637D",
              border: 1,
              borderColor: "#f2f6fd",
              borderRadius: "40px",
              mr: 1,
            }}
            startIcon={
              <OpenInNew
                sx={{ width: "14px", height: "14px", color: "#00637D" }}
              />
            }
          >
            View Candidate
          </Link>
          {/* <JobCriteriaPopup assessment={assessment}>
            <Box borderRadius='40px' p={1} border={1} borderColor='#F2F6FD'>
              <Typography color='#762FDE' fontFamily='Outfit' fontSize='13px'>Criteria</Typography>
            </Box>
          </JobCriteriaPopup> */}
        </Box>
        {/* <IconButton>
          <MoreHoriz />
        </IconButton> */}
      </Box>
    </Card>
  );
};

const mapStateToProps = (state, props) => ({
  assessment: selectAssessmentById(state, props?.id),
});

export default connect(mapStateToProps)(AssessmentGridViewCard);
